import { render, staticRenderFns } from "./AppSponsor.vue?vue&type=template&id=16c68eec&scoped=true&"
import script from "./AppSponsor.vue?vue&type=script&lang=js&"
export * from "./AppSponsor.vue?vue&type=script&lang=js&"
import style0 from "./AppSponsor.vue?vue&type=style&index=0&id=16c68eec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c68eec",
  null
  
)

export default component.exports